export default interface SubscriptionsSection {
  tierContentType?: SubscriptionsTierContentType;
  selectedTierEntityId?: string | number | null;
}

export enum SubscriptionsTierContentType {
  DEVIATIONS = 'deviations',
  POSTS = 'posts',
}
